import cx from 'classnames'
import { Pressable } from '@react-aria/interactions'

import Styles from './AiGenerationRow.module.scss'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'

import { Button } from 'blaze-ui/Button'
import { useImageMenuContext } from '../ImageMenuContext'
import { AI } from 'blaze-ui/icons'
import { TRENDING_EXAMPLES } from 'components/GenerateImageModal/GenerateImageModal'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const AiGenerationRow = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { setProvider, selectedImages, toggleSelectedImage, hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('ai') || hiddenProviders.includes('hardcodedAi')) return null

  return (
    <div className={cx(Styles.row, Styles.uploadsRow, Styles.container)}>
      <div className={Styles.rowHeader}>
        <Heading level={isSystemRedesignEnabled ? 5 : 4} color="var(--dark-80)">
          Generate with AI
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('ai')}>
          Generate your own
        </Button>
      </div>
      <Carousel offset={20}>
        <Pressable onPress={() => setProvider('ai')}>
          <div className={Styles.aiCard}>
            <AI size={24} color="var(--selected-fill)" />
            <span>Create your own</span>
          </div>
        </Pressable>
        {TRENDING_EXAMPLES.map((trendingExample) => (
          <SelectableFile
            key={trendingExample.prompt}
            onSelect={() =>
              toggleSelectedImage({ ...trendingExample, url: trendingExample.imageUrl, provider: 'hardcodedAi' })
            }
            isSelected={selectedImages.some((i) => i.url === trendingExample.imageUrl)}
          >
            <img src={trendingExample.imageUrl} alt="" />
          </SelectableFile>
        ))}
      </Carousel>
    </div>
  )
}
